<template>
    <v-app style="background-image: linear-gradient(to bottom,rgba(187, 35, 35, 0.73), rgba(58, 18, 18, 0.73)), url('https://images.pexels.com/photos/1106468/pexels-photo-1106468.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1');background-size:cover;">
      <div style="text-align:right">
        <v-btn to="/login" class="ma-2 txt_dec" outline large fab color="orange">
          <v-icon class="vbtn" color="white">close</v-icon>
        </v-btn>
      </div>
      <v-content>
        <v-container>
          <div style="text-align:center;padding-top:4%">
            <img class="center" src="../../assets/worldwin-logo-1.png" />
            <h1 style="font-weight:bold;font-size:50px;color:whitesmoke;">Partner Login Panel</h1>
            <div class="row" style="margin:0px;padding-top:35px;text-align:center!important;">
              <div class="col">
              
                 
    <v-card class="mx-auto px-6 py-8" max-width="430" style="border-radius:20px">
      <v-form>
                     <v-layout row wrap style="margin-top:20px">
                       <v-flex xs12 sm12 md12>
                        <p style="color:#ff0000;font-weight: 500; font-size: 25px;" class="txt"> Partner Login</p>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="padding-right:20px;">
                        
                          <v-text-field
                          v-model="UserName"
                          append-icon="person"
                          name="login"
                          label="Username"
                          type="text"
                          ></v-text-field>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="padding-right:20px;">
                         <v-text-field
                           v-model="Password"
                           :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                           :type="passwordShow ? 'text' : 'password'"
                           @click:append="passwordShow = !passwordShow"
                           name="password"
                           label="Password"
                         ></v-text-field>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="text-align:right">
                          <v-btn
                            depressed
                            color=""
                            block
                            :loading="loginBtn"
                            class="white--text"
                            @click="login()"
                            style="background-color:#ff0000;color:#ffffff ;padding-top: 15px; padding-bottom: 15px; margin-top: 10px; margin-bottom: 20px; border-radius: 10  px;"
                          >
                            LOGIN
                          </v-btn>
                          
                       </v-flex>
                       

                     </v-layout>
                  
                </v-form>
      <!-- <v-form
        
      >
      <p style="color:#ff0000;font-weight: 500; font-size: 25px;" class="txt"> Student Login</p>

        <v-text-field
          v-model="UserName"
          :readonly="loading"
          :rules="[required]"
          class="mb-3"
          clearable
          label="User ID"
          variant="outlined"
        ></v-text-field>

        <v-text-field
          v-model="Password"
          :readonly="loading"
          :rules="[required]"
          clearable
          label="Password"
          placeholder="Enter your password"
        ></v-text-field>

        <br>

        <v-btn
          :loading="loading"
          block
          color=""
          size="large"
          type="submit"
          @click="login()"
          style="background-color:#ff0000;color:#ffffff ;padding-top: 15px; padding-bottom: 15px; margin-top: 10px; margin-bottom: 20px; border-radius: 10  px;"
        >
          Log In
        </v-btn>
      </v-form> -->
    </v-card>

       
              </div>

            </div>
          </div>
        </v-container>
      </v-content>
  
      <!-- <v-footer class="black--text pa-4" style="background-color:#fcd5a6">
        <v-spacer></v-spacer>
        <div>
          &copy; {{ new Date().getFullYear() }} Developed with 💖 by
          <a
            href="http://infosyst.in/"
          >Infosyst</a>
        </div>&nbsp;&nbsp;&nbsp;&nbsp;
      </v-footer> -->
    </v-app>
  </template>
  <script>
  import { useRouter } from 'vue-router'
  export default {
    data: () => ({
      form: false,
      email: null,
      password: null,
      loading: false,
      UserName: null,
      Password: null,
      passwordShow: false,

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
    }),

    methods: {

      login() {
      this.loginBtn = true
      let UserName = this.UserName;
      let Password = this.Password;
      this.loading = true;
      this.$store
        .dispatch("login", { UserName, Password })
        .then(() => {
          /* if (localStorage.roles === 'Member') {
            this.$router.go(-1);
            this.loading = false;
          }
          else { */
            //this.$router.push("/dashboard");
            console.log('Hello Router');
            this.$router.push("/subagent-dashboard");
            /* const routeData = this.$router.resolve({path: '/subagent-dashboard'});
            window.open(routeData.href, '_blank'); */
            this.loading = false;
          /* } */
        })
        .catch(err => {
          this.loading = false;
          this.loginBtn = false;
          this.$toaster.error("Wrong Username or Password");
        });

    },
      onSubmit () {
        this.$router.push("/dashboard");
    }
  }
  }
</script>